import { NanoID } from '../../types';
import { SearchFilterNanoID } from '../searchFilters/searchFiltersTypes';
import { UserGroupID, UserID, UserUUID } from '../users/usersTypes';
import {
  TeamClientStatusesEnum,
  TeamID,
  TeamNanoID,
  TeamNewFinStatusesEnum
} from './teamsTypes';

export class TeamCache {
  static proformaBlockingJobsCacheKey(companyNanoId: TeamNanoID) {
    return `company-proforma-${companyNanoId}-blocking-jobs`;
  }

  static showCacheKey() {
    return 'team';
  }

  static showTeamUsersCacheKey() {
    return 'team-users';
  }

  static showFinTeamStatusCacheKey() {
    return 'fin-team-status';
  }

  static showBillingInfoCacheKey() {
    return 'team-billing-info';
  }

  static showCompanyCacheKey() {
    return 'company';
  }

  static showFinCompanyCacheKey() {
    return 'fin-company';
  }

  static showCompanyBasicInfoCacheKey() {
    return 'company-basic-info';
  }

  static showCompanyIdsCacheKey() {
    return 'company-ids';
  }

  static showCompanyRevenueCacheKey() {
    return 'company-revenue';
  }

  static showCompanyAccountReceivablesCacheKey() {
    return 'company-account-receivables';
  }

  static showCompanyItemTypesCacheKey() {
    return 'company-item-types';
  }

  static showCompanyAddFundsCacheKey() {
    return 'company-add-funds';
  }

  static showCompanyTimeZoneCacheKey() {
    return 'company-time-zone';
  }

  static showTeamItemSidebarCacheKey() {
    return 'team-item-sidebar';
  }

  static showRedirectCacheKey(teamId: TeamID) {
    return `team-${teamId}-redirect`;
  }

  static showShortInfoCacheKey(teamId: TeamID) {
    return `team-${teamId}-short-info`;
  }

  static teamUsersAndContractorsCacheKey(teamId: TeamID) {
    return `team-${teamId}-users-and-contractors`;
  }

  static indexSelectCacheKey(fieldName: string) {
    return `teams-select-${fieldName}`;
  }

  static defaultSelectCacheKey(fieldName: string) {
    return `default-teams-select-${fieldName}`;
  }

  static selectFieldCacheKey() {
    return 'select-field-teams';
  }

  static selectFieldSelectedTeamsCacheKey() {
    return 'select-field-teams-selected-teams';
  }

  static teamsMultiSelectFieldCacheKey() {
    return 'teams-multi-select-field';
  }

  static selectedTeamsMultiSelectFieldCacheKey(name: string) {
    return `selected-teams-multi-select-${name}-field`;
  }

  static companiesCacheKey() {
    return 'companies';
  }

  static companiesViewCacheKey(viewNanoId: NanoID) {
    return `companies-view-${viewNanoId}`;
  }

  static companiesMyCompaniesCacheKey() {
    return 'companies-my-companies';
  }

  static companiesCompactMyCompaniesCacheKey() {
    return 'companies-compact-my-companies';
  }

  static companiesMyActiveCompaniesCacheKey() {
    return 'companies-my-active-companies';
  }

  static companiesUnassignedCacheKey() {
    return 'companies-unassigned';
  }

  static companiesCompactUnassignedCacheKey() {
    return 'companies-compact-unassigned';
  }

  static companiesFavoriteCacheKey() {
    return 'companies-favorite';
  }

  static companiesCompactFavoriteCacheKey() {
    return 'companies-compact-favorite';
  }

  static companiesBlockedCacheKey() {
    return 'companies-blocked';
  }

  static companiesCompactBlockedCacheKey() {
    return 'companies-compact-blocked';
  }

  static companiesStatusCacheKey(teamClientStatus: TeamClientStatusesEnum) {
    return `companies-status-${teamClientStatus}`;
  }

  static companiesCompactStatusCacheKey(
    teamClientStatus: TeamClientStatusesEnum
  ) {
    return `companies-compact-status-${teamClientStatus}`;
  }

  static companiesTotalCountStatusCacheKey(
    teamClientStatus: TeamClientStatusesEnum
  ) {
    return `companies-total-count-status-${teamClientStatus}`;
  }

  static companiesTotalCountNewFinStatusCacheKey(
    teamNewFinStatus: TeamNewFinStatusesEnum,
    pathname?: string
  ) {
    return `companies-total-count-new-fin-status-${teamNewFinStatus}-${
      pathname || ''
    }`;
  }

  static companiesTotalCountFinStatusCacheKey(
    teamClientStatus: TeamClientStatusesEnum
  ) {
    return `companies-total-count-fin-status-${teamClientStatus}`;
  }

  static filteredCompaniesCacheKey(searchFilterNanoId: SearchFilterNanoID) {
    return `companies-filtered-${searchFilterNanoId}`;
  }

  static filteredCompaniesCompactCacheKey(
    searchFilterNanoId: SearchFilterNanoID
  ) {
    return `companies-compact-filtered-${searchFilterNanoId}`;
  }

  static performersCacheKey() {
    return 'performer-companies';
  }

  static performersFavoriteCacheKey() {
    return 'performer-companies-favorite';
  }

  static performersBlockedCacheKey() {
    return 'performer-companies-blocked';
  }

  static performersUnassignedCacheKey() {
    return 'performer-companies-unassigned';
  }

  static performersMyPerformersCacheKey() {
    return 'performer-companies-my-performers';
  }

  static filteredPerformersCacheKey(searchFilterNanoId: SearchFilterNanoID) {
    return `performer-companies-filtered-${searchFilterNanoId}`;
  }

  static userCompany(id: UserUUID | UserID) {
    return `user-${id}-company`;
  }

  static userGroupCompanies(id: UserGroupID) {
    return `user-group-${id}-companies`;
  }

  static indexUserGroupCompanies() {
    return 'user-group-companies';
  }

  static selectedTeamSelectFieldCacheKey(fieldName: string) {
    return `team-select-field-${fieldName}`;
  }

  static smartContractCompaniesCacheKey() {
    return 'smart-contract-companies';
  }

  static filesCacheKey(teamId: TeamID) {
    return `team-${teamId}-files`;
  }

  static imagesCacheKey(teamId: TeamID) {
    return `team-${teamId}-images`;
  }
}
